import { Toast } from 'antd-mobile'
import { replace } from 'connected-react-router'
import { login } from 'store/siteConfig'
export default function resultHandle(result, dispatch, success, error) {
  if (result.httpStatusCode) {
    switch (result.httpStatusCode) {
      case 200:
        !result.data && (result.data = {})
        typeof success === 'function' && success(result.data)
        break
      default:
        result.error && Toast.info(`${result.error.message}`, 3.5)
        typeof error === 'function' && error(result)
        break
    }
    return Object.assign(result.data || {}, {
      isFetching: false,
    })
  } else {
    switch (result.head?.code) {
      case '200':
        !result.body && (result.body = {})
        typeof success === 'function' && success(result.body)
        break
      case '401':
      case '403':
      case '406':
      case '409':
        dispatch(login())
        break
      case '66054':
        // 当前付款方与订单中的付款方不一致
        if (typeof error === 'function') {
          error(result)
        } else {
          result.head.msg && Toast.info(`${result.head.msg}[${result.head.traceCode}]`, 3.5)
        }
        break
      case '60012':
      case '60013':
      case 'INVOICE_ORDER_NOT_EXIST':
        Toast.hide()
        dispatch(replace(`/error?code=${result.head.code}&msg=${result.head.msg}[${result.head.traceCode}]`))
        typeof error === 'function' && error()
        break
      default:
        result.head.msg && Toast.info(`${result.head.msg}[${result.head.traceCode}]`, 3.5)
        typeof error === 'function' && error(result)
        break
    }
  }

  return Object.assign(result.body || {}, {
    isFetching: false,
  })
}
